// When a client clicks on the Rolex menu button, toggle between showing & hiding the dropdown menu
function toggleRolexMenu() 
{
    const breadCrumbs = document.getElementById('rolexBreadcrumbs');
    const navLinks = document.getElementById('rolexNavigationLinks');
  
	if (navLinks.style.maxHeight == '1300px') 
	{
		navLinks.style.maxHeight = 0; 
		navLinks.style.opacity = 0;
		navLinks.style.top = '-25px';
        navLinks.style.opacity = 0;
        
		animateToggleArrowDown();

        if (breadCrumbs != null) { breadCrumbs.removeAttribute('style'); }
	}
	else
	{
		navLinks.style.maxHeight = '1300px'; 
		navLinks.style.opacity = 1;
		navLinks.style.top = 0;
		
		// add the width here to safeguard against undesired layouts when initially hidden in some browsers
		navLinks.style.width = '100vw'; 
		
		// add transition here to safeguard against the fade-in of links not rendering in some browsers
		navLinks.style.transition = 'max-height 0.4s ease-in-out, opacity 0.7s ease-in-out, top 0.4s ease-in-out'; 
		
		animateToggleArrowUp();

        if (breadCrumbs != null) 
        {
            document.getElementById('rolexBreadcrumbs').style.opacity = 0;
            document.getElementById('rolexBreadcrumbs').style.maxHeight = 0;
        }
	}
}

// Hide the menu if the client clicks anywhere outside of the menu when it's open
window.addEventListener('click', function(event)
{   
    const breadCrumbs = document.getElementById('rolexBreadcrumbs');
    const navLinks = document.getElementById('rolexNavigationLinks');
    const navBar = document.getElementById('rolexNavigationBar');
  
	if (!navBar.contains(event.target) && navLinks.style.maxHeight == '1200px')
  	{
		navLinks.style.maxHeight = 0; 
        if (breadCrumbs != null) { breadCrumbs.removeAttribute('style'); }
	} 
});

// Clear inline styles if the browser window is resized
function viewportWasResized() 
{
    const breadCrumbs = document.getElementById('rolexBreadcrumbs');

    if (breadCrumbs != null) { breadCrumbs.removeAttribute('style'); }
	document.getElementById('rolexNavigationLinks').removeAttribute('style');
    document.getElementById('rolexMenuToggleArrow').removeAttribute('style');   
}
window.onresize = viewportWasResized;

// Rotate animations for menu toggle arrow
// (to workaround CSS animations stacking asynchronously in some browsers)
function animateToggleArrowUp() 
{
	let id = null;
	const arrow = document.getElementById('rolexMenuToggleArrow');   
	let degrees = 0;
	clearInterval(id);
	id = setInterval(frame, 0.1);
	function frame() 
	{
		if (degrees == 180) 
		{
			clearInterval(id);
		} 
		else 
		{
			degrees+=3; 
			yPos = degrees/270 + 1/180; // nudge the position to visually balance the arrow better
			arrow.style.transform = 'translate(0,' + yPos + 'px) rotate(' + degrees + 'deg)'; 
		}
	}
}

function animateToggleArrowDown() 
{
	let id = null;
	const arrow = document.getElementById('rolexMenuToggleArrow');   
	let degrees = 180;
	clearInterval(id);
	id = setInterval(frame, 0.15);
	function frame() 
	{
		if (degrees == 0) 
		{
			clearInterval(id);
		} else 
		{
			degrees-=4; 
			yPos = degrees/270;
			arrow.style.transform = 'translate(0,' + yPos + 'px) rotate(' + degrees + 'deg)'; 
		}
	}
}